import $ from 'jquery'
import { attachDobField } from '../ghp/dobField.js'

//'use strict';

		var wc_checkout_coupons = {
			init: function() {
				$(document.body).on('click', 'a.showcoupon', this.show_coupon_form);
				$(document.body).on('click', '.eaplus-remove-coupon', this.remove_coupon);
				$(document.body).on('click', 'button[name="eaplus_apply_coupon"]', this.submit);
			},
			show_coupon_form: function () {

				$('.checkout_coupon').slideToggle(400, function() {
					$('.checkout_coupon').find(':input:eq(0)').trigger('focus');
				});
				return false;
			},
			submit: function () {

				// wc_checkout_params is required to continue, ensure the object exists
				if (typeof wc_checkout_params === 'undefined') {
					return false;
				}

				var $form = $('form[name="checkout"]');
				if ($form.is('.processing')) {
					return false;
				}

				$form.addClass('processing').block({
					message: null,
					overlayCSS: {
						background: '#fff',
						opacity: 0.6
					}
				});

				var data = {
					security: wc_checkout_params.apply_coupon_nonce,
					coupon_code: $form.find('input[name="coupon_code"]').val()
				};

				$.ajax({
					type: 'POST',
					url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'apply_coupon'),
					data: data,
					success: function(code) {
						$('.woocommerce-error, .woocommerce-message').remove();
						$form.removeClass('processing').unblock();

						if (code) {
							// $form.before(code);
							// $form.slideUp();
							$('div.coupon-form').after(code);

							$(document.body).trigger('applied_coupon_in_checkout', [data.coupon_code]);
							$(document.body).trigger('update_checkout', {
								update_shipping_method: false
							});
						}
					},
					dataType: 'html'
				});

				return false;
			},
			remove_coupon: function (e) {

				// wc_checkout_params is required to continue, ensure the object exists
				if (typeof wc_checkout_params === 'undefined') {
					return false;
				}

				e.preventDefault();
				var container = $(this).parents('.woocommerce-checkout-review-order'),
					coupon = $(this).data('coupon');

				container.addClass('processing').block({
					message: null,
					overlayCSS: {
						background: '#fff',
						opacity: 0.6
					}
				});

				var data = {
					security: wc_checkout_params.remove_coupon_nonce,
					coupon: coupon
				};

				$.ajax({
					type: 'POST',
					url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'remove_coupon'),
					data: data,
					success: function(code) {
						$('.woocommerce-error, .woocommerce-message').remove();
						container.removeClass('processing').unblock();

						if (code) {
							//$('form.woocommerce-checkout').before(code);

							$('div.cart-discount').after(code);

							$(document.body).trigger('removed_coupon_in_checkout', [data.coupon]);
							$(document.body).trigger('update_checkout', {
								update_shipping_method: false
							});

							// Remove coupon code from coupon field
							$('form.checkout_coupon').find('input[name="coupon_code"]').val('');
						}
					},
					error: function(jqXHR) {
						if (wc_checkout_params.debug_mode) {
							/* jshint devel: true */
							console.log(jqXHR.responseText);
						}
					},
					dataType: 'html'
				});
			}
		};

		wc_checkout_coupons.init();

// Checkout validation
(function() {
  'use strict';

  const PATTERNS = {
    email: /^(?=.{1,50}$).+@.{2,}\./,
    name: /^(?=.{1,14}$)[a-zA-Z \-\']*$/i,
    lastName: /^(?=.{1,15}$)[a-zA-Z \-\']*$/i,
    middleInitial: /^(?=.{0,1}$)[a-zA-Z]*$/i,
    billingAddress: /^(?=.{5,90}$)[a-zA-Z0-9\s\-\.\,\#\/\(\)]+$/,
    billingAddress2: /^$|^(?=.{1,90}$)[a-zA-Z0-9\s\-\.\,\#\/\(\)]+$/,
    shippingAddress: /^(?=.{5,30}$)[a-zA-Z0-9\s\-\.\,\#\/\(\)]+$/,
    city: /^(?=.{2,19}$)[a-zA-Z \-\']*$/i,
    zip: /^\d{5}(-\d{4})?$/,
  };

  /**
   * Create a validation handler for a field.
   * @param {string} selector - jQuery selector for the field.
   * @param {RegExp|function(string):boolean} test - Pattern or predicate to validate against.
   */
  function createFieldValidator(selector, test) {
    const isValidValue = test instanceof RegExp ? (value) => test.test(value) : test;
    $('body').on('blur change', selector, function() {
      const wrapper = $(this).closest('.form-row');
      const isValid = isValidValue($(this).val());
      wrapper.toggleClass('woocommerce-validated', isValid)
             .toggleClass('woocommerce-invalid', !isValid);
    });
  }

  /**
   * Validate a US phone number, mirroring the server's normalize_phone_to_10:
   * 10 digits, or 11 digits starting with "1".
   * @param {string} value - Raw field value.
   * @return {boolean}
   */
  function isValidUsPhone(value) {
    let digits = String(value || '').replace(/\D/g, '');
    if (digits.length === 11 && digits[0] === '1') {
      digits = digits.slice(1);
    }
    return /^\d{10}$/.test(digits);
  }

  // Billing field validators.
  createFieldValidator('#billing_email', PATTERNS.email);
  createFieldValidator('#billing_first_name', PATTERNS.name);
  createFieldValidator('#billing_middle_initial', PATTERNS.middleInitial);
  createFieldValidator('#billing_last_name', PATTERNS.lastName);
  createFieldValidator('#billing_address_1', PATTERNS.billingAddress);
  createFieldValidator('#billing_address_2', PATTERNS.billingAddress2);
  createFieldValidator('#billing_city', PATTERNS.city);
  createFieldValidator('#billing_postcode', PATTERNS.zip);
  createFieldValidator('#billing_phone', isValidUsPhone);

  // Shipping field validators.
  createFieldValidator('#shipping_address_1', PATTERNS.shippingAddress);
  createFieldValidator('#shipping_city', PATTERNS.city);
  createFieldValidator('#shipping_postcode', PATTERNS.zip);

  // Trigger checkout update when shipping address fields change (to save to session).
  var shippingUpdateTimeout;
  var shippingFields = '#shipping_address_1, #shipping_city, #shipping_state, #shipping_postcode, #ship-to-different-address-checkbox';

  $('body').on('change', shippingFields, function() {
    clearTimeout(shippingUpdateTimeout);
    shippingUpdateTimeout = setTimeout(function() {
      $(document.body).trigger('update_checkout', { update_shipping_method: false });
    }, 500);
  });

  function excludedStates() {
    return (typeof EAPLUS_VARS !== 'undefined' && Array.isArray(EAPLUS_VARS.excluded_states))
      ? EAPLUS_VARS.excluded_states
      : [];
  }

  $('body').on('change', '#billing_state, #shipping_state', function() {
    var prefix = this.id === 'billing_state' ? 'billing' : 'shipping';

    if ($.inArray(String($(this).val() || '').toUpperCase(), excludedStates()) < 0) {
      return;
    }

    ['address_1', 'address_2', 'city', 'postcode'].forEach(function(field) {
      var input = document.getElementById(prefix + '_' + field);
      if (input) input.value = '';
    });

    $(this).val('').trigger('change.select2');
    $('#checkout-notice-state').modal('show');
  });

  // Mask + validate the EA+ Date of Birth field (mirrors the GHP checkout
  // field). The field is absent on GHP carts, so attaching is a no-op there.
  // Re-run after WooCommerce refreshes the checkout in case the row is
  // re-rendered; attachDobField is idempotent.
  function initDobField() {
    attachDobField(document.getElementById('billing_ghp_primary_dob'));
  }

  $(initDobField);
  $(document.body).on('updated_checkout', initDobField);

  const RECAPTCHA_TOKEN_MAX_AGE_MS = 90000;
  const RECAPTCHA_REFRESH_TIMEOUT_MS = 5000;
  let pendingRecaptchaSubmit = null;

  function hasFreshRecaptchaToken(form) {
    const field = form.querySelector('.agr-recaptcha-response');
    if (!field) {
      return true;
    }
    const tokenTime = parseInt(field.getAttribute('data-token-time') || '0', 10);
    return Boolean(field.value) && Date.now() - tokenTime < RECAPTCHA_TOKEN_MAX_AGE_MS;
  }

  window.addEventListener('submit', function(e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form.checkout') || typeof window.wpcaptchaRefreshToken !== 'function' || hasFreshRecaptchaToken(form)) {
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    if (pendingRecaptchaSubmit) {
      return;
    }
    const submitOnce = () => {
      if (!pendingRecaptchaSubmit) {
        return;
      }
      clearTimeout(pendingRecaptchaSubmit);
      pendingRecaptchaSubmit = null;
      $(form).trigger('submit');
    };
    pendingRecaptchaSubmit = setTimeout(submitOnce, RECAPTCHA_REFRESH_TIMEOUT_MS);
    window.wpcaptchaRefreshToken(submitOnce);
  }, true);
})();
